import styled from 'styled-components';

interface SidebarOpenProps {
  isSidebarOpen: boolean;
}

const RootWrapper = styled.div<SidebarOpenProps>`
  display: flex;
  flex-shrink: 0;
  transition: width 0.3s ease-out;
  width: ${({ isSidebarOpen, theme }) =>
    isSidebarOpen ? theme.spacing(33) : theme.spacing(9)};
`;

const SidebarWrapper = styled.div<SidebarOpenProps>`
  background: ${({ theme }) => theme.palette.primary.light};
  display: flex;
  flex-direction: column;
  font-family: ${({ theme }) => theme.typography.fontFamily};
  font-size: ${({ theme }) => theme.typography.fontSize};
  height: 100%;
  line-height: ${({ theme }) => theme.typography.body2.lineHeight};
  overflow: hidden;
  transition: width 0.3s ease-out;
  width: ${({ isSidebarOpen, theme }) =>
    isSidebarOpen ? theme.spacing(36) : theme.spacing(12)};
  word-break: ${({ isSidebarOpen }) =>
    isSidebarOpen ? 'break-word' : 'normal'};

  img,
  svg {
    vertical-align: middle;
  }
`;

const ContentWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: space-between;
  overflow-x: auto;
`;

export { ContentWrapper, RootWrapper, SidebarWrapper };
